<img #headerLogo [src]="mainLogoSrc | safeHtml:'resourceUrl'" alt="{{getCompanyName() || 'Company'}} Logo: Go to Home Page" (error)="imageLoadErrorHandler(headerLogo)">
